<script setup lang="ts">
import { ref } from 'vue'
import { logsApi } from '@/api/logs'
import { getSessionIdForReport } from '@/utils/sessionLogger'

const props = defineProps<{
  area: string
  label?: string
  tip?: string
}>()

const open = ref(false)
const submitting = ref(false)
const description = ref('')
const category = ref<'poprawka' | 'nowa_funkcja' | 'pytanie'>('poprawka')


async function handleSubmit() {
  if (!description.value.trim()) return
  submitting.value = true
  try {
    await logsApi.sendIssueReport({
      session_id: getSessionIdForReport(),
      area: props.area,
      content: description.value.trim(),
      category: category.value
    })
    description.value = ''
    category.value = 'poprawka'
    open.value = false
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <div class="relative inline-flex group">
    <button
      class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-[11px] font-semibold text-white hover:bg-orange-600"
      @click="open = true"
      title="Zgłoś"
      aria-label="Zgłoś"
    >
      <span>?</span>
    </button>
    <div
      v-if="tip && tip.trim().length"
      class="pointer-events-none absolute left-1/2 top-full z-10 mt-2 w-max -translate-x-1/2 rounded bg-primary-900 px-2 py-1 text-[11px] text-white opacity-0 shadow group-hover:opacity-100"
    >
      {{ tip }}
    </div>
  </div>

  <teleport to="body">
    <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/40" @click="open = false"></div>
      <div class="relative w-full max-w-md rounded-lg bg-white p-4 shadow-xl">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-primary-900">Zgłoszenie</h3>
          <button class="text-primary-400 hover:text-primary-600" @click="open = false">
            ✕
          </button>
        </div>

        <div class="space-y-3">
          <div>
            <label class="block text-xs text-primary-500 mb-1">Kategoria</label>
            <select
              v-model="category"
              class="w-full rounded-md border border-surface-300 px-3 py-2 text-sm"
            >
              <option value="poprawka">Poprawka</option>
              <option value="nowa_funkcja">Nowa funkcja</option>
              <option value="pytanie">Pytanie</option>
            </select>
          </div>

          <div>
            <label class="block text-xs text-primary-500 mb-1">Opis</label>
            <textarea
              v-model="description"
              rows="4"
              placeholder="Opisz problem lub pomysł..."
              class="w-full rounded-md border border-surface-300 px-3 py-2 text-sm"
            ></textarea>
          </div>
        </div>

        <div class="mt-4 flex justify-end gap-2">
          <button
            class="px-3 py-1.5 text-sm text-primary-600 hover:text-primary-800"
            @click="open = false"
          >
            Anuluj
          </button>
          <button
            class="px-3 py-1.5 text-sm text-white bg-accent-blue rounded-md hover:bg-accent-blue/90 disabled:opacity-50"
            :disabled="submitting || !description.trim()"
            @click="handleSubmit"
          >
            Wyślij
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>
